import { render, staticRenderFns } from "./ReferenceGenerator.vue?vue&type=template&id=0f465001&"
import script from "./ReferenceGenerator.vue?vue&type=script&lang=ts&"
export * from "./ReferenceGenerator.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports